import {Divider} from '@mantine/core';
import Image from 'next/image';
import {MdIosShare} from 'react-icons/md';
import {CommonLink} from '../../../../../shared/components/CommonLink';
import {ShareButton} from '../../../../../shared/components/ShareButton';
import {FollowCompanyButton} from '../../../../company/components/FollowButton';

type Props = {
  companyId: number;
  companyName: string;
  companyIndustry: string;
  companyLogoImageUrl: string;
  companyIsFollowed: boolean;
  companyFollowerCount: number;
  hasReport: boolean;
  shareTitle: string;
  shareUrl: string;
  isLoading?: boolean;
};

export const RecruitmentLeftColumn: React.FC<Props> = ({
  companyId,
  companyName,
  companyIndustry,
  companyLogoImageUrl,
  companyIsFollowed,
  companyFollowerCount,
  hasReport,
  shareTitle,
  shareUrl,
  isLoading = false,
}) => {
  return (
    <div className="flex flex-col w-[370px] gap-16">
      <div className="w-full flex flex-col bg-white rounded-16 p-16 gap-8">
        {companyLogoImageUrl && (
          <CommonLink href={`/company/${companyId}`}>
            <Image
              className="h-[75px] w-[100px] bg-white object-contain relative cursor-pointer mb-4"
              src={companyLogoImageUrl}
              alt={companyName}
              width={100}
              height={75}
            />
          </CommonLink>
        )}
        <div className="flex justify-between items-center">
          <div className="flex flex-col">
            {companyName && (
              <h2 className="text-lg leading font-bold">{companyName}</h2>
            )}
            {companyIndustry && (
              <div className="text-black-3 text-base">{companyIndustry}</div>
            )}
          </div>
          <ShareButton
            title={shareTitle}
            url={shareUrl}
            variant="white"
            className="flex items-center justify-center bg-black-5 rounded-full w-[36px] h-[36px] pc:w-[44px] pc:h-[44px] hover:opacity-70"
          >
            <MdIosShare size={24} color="#000" />
          </ShareButton>
        </div>
        {!isLoading && (
          <FollowCompanyButton
            companyId={companyId}
            initial={{
              isFollowed: companyIsFollowed,
              followerCount: companyFollowerCount,
            }}
          />
        )}
      </div>
      <div className="bg-white p-16 rounded-16">
        <div className="font-bold">関連ページ</div>
        <Divider className="my-8" />
        <div className="flex flex-col gap-8">
          {companyId && (
            <CommonLink
              href={`/company/${companyId}`}
              className="hover:opacity-60 leading"
            >
              企業情報
            </CommonLink>
          )}
          {hasReport && (
            <CommonLink
              href={`/company/${companyId}/experiences`}
              className="hover:opacity-60 leading"
            >
              ES・体験記
            </CommonLink>
          )}
        </div>
      </div>
    </div>
  );
};
